<!-- A control that navigates stays an anchor, so the browser keeps middle-click, right-click
     and "open in new tab"; one that acts in place stays a button. Material dresses both. -->
<a *ngIf="link; else actionButton"
  mat-button
  class="underline-button"
  [ngClass]="size === 'sm' ? 'underline-button--sm' : 'underline-button--md'"
  [routerLink]="link"
  [queryParams]="queryParams">
  <ng-container *ngTemplateOutlet="row"></ng-container>
</a>

<ng-template #actionButton>
  <button
    mat-button
    type="button"
    class="underline-button"
    [ngClass]="size === 'sm' ? 'underline-button--sm' : 'underline-button--md'"
    [disabled]="disabled"
    (click)="pressed.emit()">
    <ng-container *ngTemplateOutlet="row"></ng-container>
  </button>
</ng-template>

<ng-template #row>
  <span class="underline-button__row inline-flex items-center justify-center" [ngClass]="size === 'sm' ? 'gap-1' : 'gap-2'">
    <mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon" class="underline-button__icon shrink-0"></mat-icon>
    <span class="underline"><ng-content></ng-content></span>
  </span>
</ng-template>
